 /*
    -------------------------------------------------------
    table of content
    -------------------------------------------------------
    */


document.addEventListener('DOMContentLoaded', function () {
  const article = document.querySelector('[data-aham-article]');
  const toc = document.getElementById('article-toc-list');

  if (!article || !toc) return;

  const headings = article.querySelectorAll('h2, h3');

  if (!headings.length) {
    const tocContainer = toc.closest('.article-toc');
    if (tocContainer) tocContainer.remove();
    return;
  }

  let sectionNumber = 0;
  let currentH2List = null;

  headings.forEach(function (heading) {
    const text = heading.textContent.trim();

    if (!text) return;

    /*
    -------------------------------------------------------
    Create a stable ID
    -------------------------------------------------------
    */

    if (!heading.id) {
      let baseId = text
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

      if (!baseId) {
        baseId = 'section';
      }

      let id = baseId;
      let counter = 2;

      while (document.getElementById(id)) {
        id = baseId + '-' + counter;
        counter++;
      }

      heading.id = id;
    }

    /*
    -------------------------------------------------------
    H2
    -------------------------------------------------------
    */

    if (heading.tagName.toLowerCase() === 'h2') {
      sectionNumber++;

      const li = document.createElement('li');
      li.className = 'toc-item toc-item--h2';

      const link = document.createElement('a');
      link.href = '#' + heading.id;

      const number = document.createElement('span');
      number.className = 'toc-number';
      number.textContent = String(sectionNumber).padStart(2, '0');

      const title = document.createElement('span');
      title.className = 'toc-text';
      title.textContent = text;

      link.appendChild(number);
      link.appendChild(title);
      li.appendChild(link);

      toc.appendChild(li);

      /*
      Create a sub-list for H3 items
      */
      currentH2List = document.createElement('ol');
      currentH2List.className = 'toc-sublist';

      li.appendChild(currentH2List);

      return;
    }

    /*
    -------------------------------------------------------
    H3
    -------------------------------------------------------
    */

    if (
      heading.tagName.toLowerCase() === 'h3' &&
      currentH2List
    ) {
      const li = document.createElement('li');
      li.className = 'toc-item toc-item--h3';

      const link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = text;

      li.appendChild(link);
      currentH2List.appendChild(li);
    }
  });

  /*
  -------------------------------------------------------
  Smooth scrolling
  -------------------------------------------------------
  */

  toc.querySelectorAll('a').forEach(function (link) {
    link.addEventListener('click', function (event) {
      const targetId = this.getAttribute('href');

      if (!targetId || targetId === '#') return;

      const target = document.querySelector(targetId);

      if (!target) return;

      event.preventDefault();

      const headerOffset = 100;

      const targetPosition =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        headerOffset;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });

      history.replaceState(null, '', targetId);
    });
  });
});